import type { TmWrappers } from '@/wrappers'
import type { FiltersToCreate } from '@/services/tables/filters/types'

export const addSmsSurveyRecipientsModalId: TmWrappers = 'smsSurveyRecipients'

export const smsSurveyRecipientsCountriesFilterFields = {
  phones: 'phones',
  contacts: 'contacts',
  lists: 'lists',
  filteredViews: 'filteredViews',
  folders: 'folders',
}

export const smsSurveyRecipientsCountriesFilters: FiltersToCreate = [
  {
    name: smsSurveyRecipientsCountriesFilterFields.phones,
    operation: 'eq',
  },
  {
    name: smsSurveyRecipientsCountriesFilterFields.contacts,
    operation: 'eq',
  },
  {
    name: smsSurveyRecipientsCountriesFilterFields.lists,
    operation: 'eq',
  },
  {
    name: smsSurveyRecipientsCountriesFilterFields.filteredViews,
    operation: 'eq',
  },
  {
    name: smsSurveyRecipientsCountriesFilterFields.folders,
    operation: 'eq',
  },
]
